import { useAuthContext } from "../../hooks/use-auth-context.js";
import { useLayoutEffect } from "react";

//#region src/client/components/routes/LogoutRoute.tsx
const LogoutRoute = ({ returnUrl }) => {
	const ctx = useAuthContext();
	useLayoutEffect(() => {
		ctx.signOut(returnUrl);
	}, [ctx, returnUrl]);
	return null;
};

//#endregion
export { LogoutRoute };